export default __webpack_public_path__ + "static/media/paper.745ad06a.svg";